import { DomSanitizer } from '@angular/platform-browser';
import { upperFirst } from 'lodash';
import { TranslocoService } from '@ngneat/transloco';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FaqService } from './faq.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kt-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit, OnDestroy {
  faq$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  private unsubscribe: Subject<any>;

  constructor(private transloco: TranslocoService, private sanitizer: DomSanitizer, private service: FaqService) {
    this.unsubscribe = new Subject<any>();
  }

  ngOnInit() {
    this.service
      .getList()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ faq }) => this.faq$.next(faq));
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getQuestion(item: any) {
    const lang = upperFirst(this.transloco.getActiveLang());
    return item[`question${lang}`];
  }

  getAnswer(item: any) {
    const lang = upperFirst(this.transloco.getActiveLang());
    return this.sanitizer.bypassSecurityTrustHtml(item[`answer${lang}`]);
  }
}
